import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const AltaVisitorSvg = ({ ...svgProps }) => (
  <SvgWrapper
    data-testid="native-app-visitor-icon"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 9C26.43 9 28 10.57 28 12.5V32.5C28 34.43 26.43 36 24.5 36H11.5C9.57 36 8 34.43 8 32.5V12.5C8 10.57 9.57 9 11.5 9H24.5ZM13.5 27C12.67 27 12 27.67 12 28.5C12 29.33 12.67 30 13.5 30H22.5C23.33 30 24 29.33 24 28.5C24 27.67 23.33 27 22.5 27H13.5ZM18 15C15.7909 15 14 16.7909 14 19C14 21.2091 15.7909 23 18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15Z"
    />
    <path
      opacity="0.6"
      d="M19.0605 6.56055C18.4748 7.14632 17.5252 7.14628 16.9395 6.56055L10.3789 0H14.6211L18 3.37891L21.3789 0H25.6211L19.0605 6.56055Z"
    />
  </SvgWrapper>
);
